import { render, staticRenderFns } from "./formConfirmarAlteracao.vue?vue&type=template&id=38d31436&scoped=true&"
import script from "./formConfirmarAlteracao.vue?vue&type=script&lang=js&"
export * from "./formConfirmarAlteracao.vue?vue&type=script&lang=js&"
import style0 from "./formConfirmarAlteracao.vue?vue&type=style&index=0&id=38d31436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d31436",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VSpacer,VTextField,VToolbar})
